/**
 * Update a state drop down to populate with codes from the selected country.
 */
export class StateSelector {
    /**
     * Loads a new State Selector from the company selected.
     */
    constructor() {
        this.init();
    }

    /**
     * Bind the elements to their listeners.
     *
     * @returns {void}
     */
    init() : void{
        const country = document.getElementById('country');
        country.addEventListener('change', this.updateStateDropDown.bind(this));
    }

    /**
     * Handles the change event for a country being changed.
     *
     * @listens change
     * @param {Event} e from change event
     * @returns {void}
     */
    updateStateDropDown(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = {
            result_ids: 'state-div',
            country: /** @type {HTMLInputElement} */ (e.currentTarget).value
        };

        $.ceAjax('request', 'index.php?dispatch=tv_utils.update_states_drop_down', {
            'full_render': false,
            'method': 'POST',
            'caching': false,
            'data': data
        });
    }

}